<template>
  <fragment>
    <!-- PAGE HEADER START -->
    <hero-header :hero-title="brand.brandName" page-name="pageBrand.repairInformationsAndManufacturersContact" />
    <!-- PAGE HEADER END -->
    <!-- AVAILABLE PRODUCTS START -->
    <fragment v-if="brand.productGroups && brand.productGroups.length > 0">
      <fancy-headline title="pageBrand.productsForRepair" />
      <v-container class="mb-10">
        <v-row justify="center">
          <template v-for="(availableProduct, index) in brand.productGroups">
            <v-col cols="12" sm="6" md="3" :key="index">
              <available-product-card :product="availableProduct"/>
            </v-col>
          </template>
        </v-row>
        <v-row v-if="brand.availableDesc !== ''" class="mt-5">
          <v-col cols="12">
            <div v-html="$t(brand.availableDesc)" />
          </v-col>
        </v-row>
      </v-container>
    </fragment>
    <!-- AVAILABLE PRODUCTS END -->
    <!-- MOBILFUTAR BANNER START -->
    <fragment v-if="showMobilfutarBanner.includes(brand.brandName)">
      <!--<information-strip title="Próbálja ki ingyenes háztól-házig szerviz szolgáltatásunkat, a Mobilfutárt."
                         button-text="Tovább" button-link="/mobilfutar"
                         font-weight="regular"
                         background-color="warning"></information-strip>-->
      <v-container fluid class="warning">
        <v-container class="my-10">
          <v-row align="center">
            <v-col cols="12" sm="8" :class="$vuetify.breakpoint.smAndDown ? 'mb-6' : ''">
            <span :class="$vuetify.breakpoint.smAndDown ? `display-1 font-weight-regular white--text` : `display-2 font-weight-regular white--text`">
              Próbálja ki ingyenes háztól-házig szerviz szolgáltatásunkat, a Mobilfutárt.
            </span>
            </v-col>
            <v-col cols="12" sm="4" style="text-align: center;">
              <v-btn class="white" x-large rounded @click="goToMobilfutar" min-width="148">
                Tovább
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </fragment>
    <!-- MOBILFUTAR BANNER START -->
    <!-- MOBILFUTAR BANNER START -->
    <fragment v-if="brand.brandName === 'Xiaomi'">
      <!--<information-strip title="Próbálja ki ingyenes háztól-házig szerviz szolgáltatásunkat, a Mobilfutárt."
                         button-text="Tovább" button-link="/mobilfutar/xiaomi"
                         font-weight="regular"
                         background-color="warning"></information-strip>-->
      <v-container fluid class="warning">
        <v-container class="my-10">
          <v-row align="center">
            <v-col cols="12" sm="8" :class="$vuetify.breakpoint.smAndDown ? 'mb-6' : ''">
            <span :class="$vuetify.breakpoint.smAndDown ? `display-1 font-weight-regular white--text` : `display-2 font-weight-regular white--text`">
              Próbálja ki ingyenes háztól-házig szerviz szolgáltatásunkat, a Mobilfutárt.
            </span>
            </v-col>
            <v-col cols="12" sm="4" style="text-align: center;">
              <v-btn class="white" x-large rounded @click="goToMobilfutar" min-width="148">
                Tovább
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </fragment>
    <!-- MOBILFUTAR BANNER START -->
    <!-- SZERVIZSZOLG SECTION START -->
    <v-container class="mt-5">
      <v-row class="mt-5">
        <v-col cols="12" class="mb-10">
          <h1 class="text-center">
            {{ $t('pageBrand.repairServiceAndPickupOpportunities') }}
          </h1>
        </v-col>
        <v-col cols="12" class="mt-10">
          <div v-html="$t(brand.mapInfo)"></div>
        </v-col>
      </v-row>
    </v-container>
    <!-- SZERVIZSZOLG SECTION START -->
    <!-- MAP START -->
    <v-container v-if="deliveryPoints !== null">
      <v-row v-if="deliveryPoints.features[0].properties.category != 'error'">
        <v-col cols="12">
          <h3>
            {{ $t('pageBrand.pickupLocations') }}
          </h3>
        </v-col>
        <v-col cols="12">
          <!-- MAP START -->
          <google-map class="webportal-google-map"
                      v-bind:geo-json="deliveryPoints"/>
          <!-- MAP END -->
        </v-col>
      </v-row>
    </v-container>
    <!-- MAP END -->
    <!-- UNAVAILABLE PRODUCTS START -->
    <fragment v-if="brand.unavailableDesc && brand.unavailableDesc.length !== 0">
      <fancy-headline title="pageBrand.productsNotRepair" />
      <v-container>
        <v-row  class="mt-5">
          <v-col cols="12">
            <div v-html="$t(brand.unavailableDesc)" />
          </v-col>
        </v-row>
      </v-container>
    </fragment>
    <!-- UNAVAILABLE PRODUCTS END -->
  </fragment>
</template>

<script>

import heroHeader from '../components/heroHeader.vue';
import fancyHeadline from '../components/fancyHeadline.vue';
import availableProductCard from '../components/availableProductCard.vue';
import googleMap from '../components/googleMap.vue';
import { customIcons } from '../plugins/mapSettings';
import { BRAND_GET_BRAND_BY_ID, BRAND_GET_DELIVERY_POINTS_BY_BRAND_ID } from '../store/getters.type';
// import informationStrip from '../components/informationStrip.vue';

export default {
  name: 'Brand',
  components: {
    heroHeader,
    fancyHeadline,
    availableProductCard,
    googleMap,
    // informationStrip,
  },
  async beforeMount() {
    this.deliveryPoints = null;
    if (this.$route.params.brandID) {
      this.brand = await this.getBrandDetails();
      if (this.brand !== {}) {
        this.deliveryPoints = await this.getDeliveryPoints(this.$route.params.brandID);
      }
    } else {
      //
    }
  },
  beforeDestroy() {
    this.deliveryPoints = null;
    this.isDeliveryPointsLoaded = false;
    this.markers = [];
  },
  data() {
    return {
      brand: {},
      deliveryPoints: null,
      sampleDeliveryPoints: {
        type: 'FeatureCollection',
        features: [
          {
            geometry: {
              type: 'Point',
              coordinates: [
                18.414639,
                47.190479,
              ],
            },
            type: 'Feature',
            properties: {
              category: 'SamsungMSC',
              hours: 'H-P 9:00-18:00, Sz 9:00-12:00',
              description: '-',
              name: 'F-concept',
              phone: '36205236900',
              address: '8000 Székesfehérvár, Távirda u.14',
              storeid: 1,
            },
          },
          {
            geometry: {
              type: 'Point',
              coordinates: [
                20.145094,
                46.255707,
              ],
            },
            type: 'Feature',
            properties: {
              category: 'SamsungMSC',
              hours: 'H-P: 08:30-18:00, Sz: 09:00-13:00',
              description: '-',
              name: 'Szuper Elszo 57 Kft.',
              phone: '3662443998',
              address: '6723 Szeged, Tábor utca 3',
              storeid: 2,
            },
          },
          {
            geometry: {
              type: 'Point',
              coordinates: [
                20.183496,
                47.177242,
              ],
            },
            type: 'Feature',
            properties: {
              category: 'SamsungMSC',
              hours: 'H-P: 08:00-17:00, Szo: 09:00-12:00',
              description: '-',
              name: 'Euromobil 98 Kft.',
              phone: '3656370195',
              address: '5000 Szolnok, Ady Endre út 15.  Pelikán bevásárló központ,',
              storeid: 3,
            },
          },
          {
            geometry: {
              type: 'Point',
              coordinates: [
                17.644615,
                47.68889,
              ],
            },
            type: 'Feature',
            properties: {
              category: 'SamsungMSC',
              hours: 'H-P: 10:00-18:00',
              description: '-',
              name: 'RAAB GSM KFT',
              phone: '3696254944;36304555908   ',
              address: '9027 Győr, Budai út 1 Árkád',
              storeid: 4,
            },
          },
          {
            geometry: {
              type: 'Point',
              coordinates: [
                18.231737,
                46.073704,
              ],
            },
            type: 'Feature',
            properties: {
              category: 'SamsungMSC',
              hours: 'H-P: 10:00-17:00',
              description: '-',
              name: 'Mobilerőd',
              phone: '36202880000',
              address: '7621 Pécs, Rákóczi út 49',
              storeid: 5,
            },
          },
        ],
      },
      showMobilfutarBanner: [
        'Asus', 'Huawei', 'Lenovo', 'Samsung', 'Okai', 'iRobot', 'TECNO', 'VIVO', 'Infinix',
      ],
    };
  },
  methods: {
    async getBrandDetails() {
      try {
        const response = await this.$store.dispatch(BRAND_GET_BRAND_BY_ID, this.$route.params.brandID);
        return response;
      } catch (err) {
        return {};
      }
    },
    /** *
     *
     * @param {Number} brandId
     * @returns {Array}
     */
    async getDeliveryPoints(brandId) {
      try {
        const response = await this.$store.dispatch(BRAND_GET_DELIVERY_POINTS_BY_BRAND_ID, brandId);
        if (Array.isArray(response.data.features) && response.data.features.length > 0) {
          const valid = {
            type: 'FeatureCollection',
            features: [],
          };
          response.data.features.forEach(item => {
            if (Array.isArray(item.geometry.coordinates)) {
              if (item.geometry.coordinates.length === 2) {
                valid.features.push(item);
              }
            }
          });
          return valid;
        }
        return {
          type: 'FeatureCollection',
          features: [
            {
              geometry: {
                type: 'Point',
                coordinates: [
                  19.040643,
                  47.494573,
                ],
              },
              type: 'Feature',
              properties: {
                category: 'error',
                hours: '',
                description: '',
                name: 'Nincs megjeleníthető leadási pont!',
                phone: '',
                address: '',
                storeid: 1,
              },
            },
          ],
        };
      } catch (err) {
        return {
          type: 'FeatureCollection',
          features: [
            {
              geometry: {
                type: 'Point',
                coordinates: [
                  19.040643,
                  47.494573,
                ],
              },
              type: 'Feature',
              properties: {
                category: 'error',
                hours: '',
                description: 'Kérjük próbálja meg később!',
                name: 'Hiba történt a térkép betöltése során',
                phone: '',
                address: '',
                storeid: 1,
              },
            },
          ],
        };
      }
    },
    /** *
     *
     * @param {Array} feature Array of delivery point objects
     * @returns {Array}
     */
    markerCompiler(feature) {
      const ms = [];
      feature.forEach(item => {
        if (Array.isArray(item.geometry.coordinates)) {
          if (item.geometry.coordinates.length === 2) {
            const markerElement = {};
            markerElement.position = { lat: item.geometry.coordinates[1], lng: item.geometry.coordinates[0] };
            markerElement.icon = customIcons[item.properties.category].icon;
            markerElement.infoText = `<h2>${item.properties.name}</h2>`
              + `<p>${item.properties.description}</p>`
              + `<p><b>Nyitva tartás:</b><br>${item.properties.hours}<br>`
              + `<p><b>Cím:</b><br>${item.properties.address}<br>`
              + `<p><b>Telefonszám:</b><br>${item.properties.phone}<br>`
              + '</p>';
            ms.push(markerElement);
          }
        }
      });
      return ms;
    },
    goToMobilfutar() {
      window.open('https://mobilfutar.tmx.hu/', '_self');
    },
  },
};
</script>

<style scoped>

</style>
